import React from "react";

export default function FlagSvgIcon() {
  return (
    <svg
      width="16"
      height="20"
      fill="none"
      viewBox="0 0 16 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        stroke="#344054"
        stroke-width="1.67"
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M1.3335 12.5003C1.3335 12.5003 2.16683 11.667 4.66683 11.667C7.16683 11.667 8.8335 13.3337 11.3335 13.3337C13.8335 13.3337 14.6668 12.5003 14.6668 12.5003V2.50033C14.6668 2.50033 13.8335 3.33366 11.3335 3.33366C8.8335 3.33366 7.16683 1.66699 4.66683 1.66699C2.16683 1.66699 1.3335 2.50033 1.3335 2.50033V12.5003ZM1.3335 12.5003V18.3337"
      />
    </svg>
  );
}
